module.exports = __webpack_public_path__ + "img/remarks-card.21c02d63.png";